import React from 'react'
import './VoltaAoTopo.scss'

class VoltaAoTopo extends React.Component {
    constructor(props) {
        super(props)
        this.voltaAoTopo = this.voltaAoTopo.bind(this)
    }

    voltaAoTopo() {
        let home = document.querySelector('#conteudoHome')
        if (home) home.scrollIntoView()
        window.scrollTo(0, 0)
        let corpo = document.querySelector('.corpo')
        if (corpo) corpo.scrollTop = 0
    }

    render() {
        return (
            <div className="posicionaVoltaTopo">
                <button className="voltaTopo" onClick={() => this.voltaAoTopo()}>
                    Voltar ao Topo
                </button>
            </div>
        )
    }
}

export default VoltaAoTopo
